import {computed, ref, watch} from "@vue/composition-api";
import store from "@/store";
import {useToast} from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import router from "@/router";
import {French} from "flatpickr/dist/l10n/fr.js";

export const useStoreHistory = () => {
    const toast = useToast();

    const isLoading = ref(false);
    const operations = ref([])
    const selectedOperation = ref(null)
    const selectedStock = ref(null)
    const operationType = ref('in')
    const fromDateRange = ref(null)
    const toDateRange = ref(null)

    const meta = ref(null);
    const perPage = ref(10);
    const currentPage = ref(1);
    const perPageOptions = [10, 25, 50, 100];
    const dataMeta = computed(() => {
        const localItemsCount = operations.value ? operations.value.length : 0;
        return {
            from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
            to: perPage.value * (currentPage.value - 1) + localItemsCount,
            of: operations.value.length,
        };
    })
    const totalOperations = computed(() => {
        return meta.total ?? 0;
    });

    const sortBy = ref("created_at");
    const isSortDirDesc = ref(true);

    const tableFields = [
        {key: 'code', label: 'Référence'},
        {key: 'date', label: 'Date'},
        {key: 'created_by', label: 'Fait par'},
    ];

    const operationTypeOptions = [
        {value: 'in', text: 'Approvisionnement'},
        {value: 'out', text: 'Sortie'},
    ];

    const datePickerConfig = {
        wrap: true,
        altFormat: "d-m-Y",
        altInput: true,
        dateFormat: "Y-m-d",
        locale: French,
    };

    const stockOptions = computed(() => {
        return [
            {
                name: "Tous les Stocks",
                slug: "all"
            },
            ...store.getters["stock/all"],
        ];
    });
    const fetchOperationsHistory = async () => {
        selectedOperation.value = null;
        try {
            const {data} = await store.dispatch('stock/getStoreOperationsHistory', {
                storeId: router.currentRoute.params.id,
                query: {
                    perPage: perPage.value,
                    page: currentPage.value,
                    sortBy: sortBy.value,
                    sortDesc: isSortDirDesc.value,
                    type: operationType.value,
                    from: fromDateRange.value,
                    to: toDateRange.value,
                }
            })

            meta.value = data?.meta
            operations.value = data?.list
        } catch (error) {
            showToast("Une erreur est survenue lors de la récupération des opérations.", 'AlertCircleIcon', 'danger')
        }
    };
    const selectOperation = async (operation) => {
        isLoading.value = true;
        try {
            const {data} = await store.dispatch('stock/fetchSpecificOperation', {
                id: operation.uid,
                type: operationType.value
            });

            selectedOperation.value = data
        } catch (error) {
            showToast("Une erreur est survenue lors de la récupération de l'opération.", 'AlertCircleIcon', 'danger')
        } finally {
            isLoading.value = false;
        }
    }

    const fetchStocksList = () => store.dispatch("stock/allStocks", router.currentRoute.params.id);

    watch([currentPage, perPage, operationType, fromDateRange, toDateRange], () => {
        fetchOperationsHistory();
    });

    const showToast = (message, icon, variant) => {
        toast({
            component: ToastificationContent,
            props: {
                title: message,
                icon: icon,
                variant: variant,
            },
        });
    }

    return {
        tableFields,
        operationTypeOptions,
        datePickerConfig,

        selectOperation,
        fetchStocksList,
        fetchOperationsHistory,

        operations,
        selectedStock,
        selectedOperation,
        stockOptions,
        operationType,
        fromDateRange,
        toDateRange,
        totalOperations,
        perPage,
        perPageOptions,
        currentPage,
        dataMeta,
    }
};